export default {
    access_denied: "Acesso negado",
    filter_placeholder: "Filtrar por Nome do Estabelecimento",
    add_place: "Adicionar Estabelecimento",
    edit_place: "Editar Estabelecimento",
    form: {
        logo: "Logo",
        logo_title: "Logo do Estabelecimento",
        name: "Nome",
        name_title: "Nome do Estabelecimento",
        slug: "Slug",
        slug_title: "Slug do Estabelecimento",
        address: "Endereço",
        address_title: "Endereço do Estabelecimento",
        address_2: "Complemento",
        address_2_title: "Complemento do Endereço do Estabelecimento",
        zone: "Bairro",
        zone_title: "Bairro do Estabelecimento",
        city: "Cidade",
        city_title: "Cidade do Estabelecimento",
        state: "Estado",
        state_title: "Estado do Estabelecimento",
        zip_code: "CEP",
        zip_code_title: "CEP do Estabelecimento",
        phone: "Telefone",
        phone_title: "Telefone do Estabelecimento",
        phone_placeholder: "(##) #####-####",
        legal_name: "Razão Social",
        legal_name_title: "Razão Social do Estabelecimento",
        tax_id: "Documento Fiscal",
        tax_id_title: "Documento Fiscal do Estabelecimento",
        email: "Email",
        email_title: "Email do Estabelecimento",
        color: "Cor",
        color_title: "Cor do Estabelecimento",
        color_placeholder: "FFFFFF",
        timezone: "Fuso horário",
        timezone_title: "Fuso horário do Estabelecimento",
        country: "País",
        country_title: "País do Estabelecimento",
        currency: "Moeda",
        currency_title: "Moeda do Estabelecimento",
        credits_per_month: "Créditos SMS por mês",
        credits_per_month_title: "Crédito do Estabelecimento",
        modules: "Módulos",
        modules_helper: "Selecione um ou mais módulos",
        modules_title: "Módulos do Estabelecimento",
        none: "Nenhum",
        all: "Todos",
        copy_automations_from: "Copiar Automações de:",
        kevi_marketing: "Acesso ao Kevi Marketing",
        kevi_chat: "Acesso ao Kevi Chat",
        yes: "Sim",
        no: "Não",
        save: "Salvar",
        notification: {
            fill_fields: "Atenção! Preencha todos os campos corretamente.",
            saved: "Dados salvos com Sucesso!",
            updated: "Estabelecimento atualizado com sucesso!",
            update_error: "Erro ao atualizar o estabelecimento.",
            load_error: "Erro ao carregar os dados do estabelecimento.",
        },
        validation: {
            logo_required: "O logo é obrigatório.",
            name_required: "O nome é obrigatório.",
            slug_required: "O slug é obrigatório.",
            slug_format:
                "O slug pode ter apenas letras mínusculas, números e -. Máximo de 20 caracteres.",
            address_required: "O endereço é obrigatório.",
            address_2_required: "O complemento é obrigatório.",
            zone_required: "O bairro é obrigatório.",
            city_required: "A cidade é obrigatória.",
            state_required: "O estado é obrigatório.",
            zip_code_required: "O CEP é obrigatório.",
            phone_required: "O telefone é obrigatório.",
            phone_format:
                "Digite um telefone válido para o país selecionado.",
            color_required: "A cor é obrigatória.",
            color_format:
                "A cor deve estar no formato hexadecimal (ex: FFFFFF).",
            credits_per_month_required:
                "Os créditos SMS por mês são obrigatórios.",
            credits_per_month_positive:
                "Os créditos SMS por mês devem ser um número positivo.",
            modules_required: "Selecione pelo menos um módulo.",
            legal_name_required: "A razão social é obrigatória.",
            tax_id_required: "O documento fiscal é obrigatório.",
            email_required: "O email é obrigatório.",
            email_format: "Digite um email válido.",
            plan_required: "O plano é obrigatório.",
            change_reason_required: "O motivo da alteração é obrigatório.",
        },
        states: {
            AC: "Acre",
            AL: "Alagoas",
            AP: "Amapá",
            AM: "Amazonas",
            BA: "Bahia",
            CE: "Ceará",
            DF: "Distrito Federal",
            ES: "Espírito Santo",
            GO: "Goiás",
            MA: "Maranhão",
            MT: "Mato Grosso",
            MS: "Mato Grosso do Sul",
            MG: "Minas Gerais",
            PA: "Pará",
            PB: "Paraíba",
            PR: "Paraná",
            PE: "Pernambuco",
            PI: "Piauí",
            RJ: "Rio de Janeiro",
            RN: "Rio Grande do Norte",
            RS: "Rio Grande do Sul",
            RO: "Rondônia",
            RR: "Roraima",
            SC: "Santa Catarina",
            SP: "São Paulo",
            SE: "Sergipe",
            TO: "Tocantins",
        },
        countries: {
            BR: "Brasil",
            US: "Estados Unidos",
            CA: "Canadá",
            AR: "Argentina",
            UY: "Uruguai",
            PY: "Paraguai",
            CL: "Chile",
            CO: "Colômbia",
            PE: "Peru",
            MX: "México",
            PT: "Portugal",
            ES: "Espanha",
            FR: "França",
            DE: "Alemanha",
            IT: "Itália",
            GB: "Reino Unido",
        },
        currencies: {
            BRL: "Real Brasileiro",
            USD: "Dólar Americano",
            CAD: "Dólar Canadense",
            EUR: "Euro",
            ARS: "Peso Argentino",
            UYU: "Peso Uruguaio",
            PYG: "Guarani Paraguaio",
            CLP: "Peso Chileno",
            COP: "Peso Colombiano",
            PEN: "Sol Peruano",
            MXN: "Peso Mexicano",
            GBP: "Libra Esterlina",
        },
    },
    branch_form: {
        title: "Adicionar Filial",
        title_label: "Título",
        title_title: "Título da Filial",
        address: "Endereço",
        address_title: "Endereço da Filial",
        address_2: "Complemento",
        zone: "Bairro",
        city: "Cidade",
        city_title: "Cidade da Filial",
        state: "Estado",
        state_title: "Estado da Filial",
        country: "País",
        country_title: "País da Filial",
        zip_code: "CEP/Código Postal",
        zip_code_title: "CEP ou Código Postal da Filial",
        phone: "Telefone",
        phone_title: "Telefone da Filial",
        phone_placeholder: "(##) #####-####",
        active: "Ativo",
        active_title: "Status da filial",
        email: "E-mail",
        email_title: "Email da Filial",
        whatsapp: "WhatsApp",
        no_whatsapp_instance: "Nenhuma instância vinculada",
        cancel: "Cancelar",
        confirm: "Confirmar",
        yes: "Sim",
        no: "Não",
        notification: {
            fill_fields: "Atenção! Preencha todos os campos corretamente.",
            saved: "Filial salva com Sucesso!",
        },
        validation: {
            title_required: "O título é obrigatório.",
            address_required: "O endereço é obrigatório.",
            city_required: "A cidade é obrigatória.",
            state_required: "O estado é obrigatório.",
            zip_code_required: "O CEP/código postal é obrigatório.",
            active_required: "O Ativo é obrigatório.",
            email_valid: "O email deve ser válido.",
            phone_required: "O telefone é obrigatório.",
            phone_format:
                "Digite um telefone válido para o país selecionado.",
        },
    },
    user_form: {
        title: "Adicionar usuário",
        name: "Nome",
        name_title: "Nome do Usuário",
        email: "E-mail",
        email_title: "Email do Usuário",
        whatsapp: "WhatsApp",
        no_whatsapp_instance: "Nenhuma instância vinculada",
        global_admin: "Administrador Global",
        global_admin_title: "Permissão do Usuário",
        global_admin_warning:
            "Este usuário terá acesso à todos os estabelecimentos da Kevi.",
        is_internal: "Uso interno da Kevi",
        is_internal_title: "Uso interno da Kevi",
        active: "Ativo",
        active_title: "Atividade do Usuário",
        branch: "Filial",
        branch_title: "Filial do Usuário",
        roles: "Cargos",
        username: "Username",
        username_title: "Username do Usuário",
        password: "Senha",
        password_title: "Senha do Usuário",
        kevi_marketing_enabled: "Acesso ao Kevi Marketing",
        kevi_marketing_enabled_title: "Permite login e uso do Kevi Marketing",
        kevi_chat_enabled: "Acesso ao Kevi Chat",
        kevi_chat_enabled_title: "Permite login e uso do Kevi Chat",
        kevi_presence: "Presença nos produtos",
        kevi_presence_hint_marketing_only:
            "Para atrelar ao Kevi Chat, defina «Acesso ao Kevi Chat» como Sim acima e salve o usuário. A sincronização é automática.",
        presence_both: "Kevi Marketing e Kevi Chat",
        presence_marketing: "Somente Kevi Marketing",
        presence_chat: "Somente Kevi Chat",
        presence_none: "Sem acesso aos produtos",
        permissions: "Permissões",
        cancel: "Cancelar",
        confirm: "Confirmar",
        yes: "Sim",
        no: "Não",
        notification: {
            fill_fields: "Atenção! Preencha todos os campos corretamente.",
            saved: "Usuário salvo com Sucesso!",
        },
        permission: {
            dashboard: "Dashboard",
            dashboard_help: "Acessa o painel e as operações do PDV.",
            inbox: "Inbox",
            inbox_help: "Acessa conversas e mensagens dos clientes.",
            tasks: "Tarefas",
            tasks_help: "Acessa e gerencia tarefas da equipe.",
            coupons: "Cupons",
            coupons_help: "Acessa criação e gestão de cupons.",
            clients: "Clientes",
            clients_help: "Acessa a base de clientes e seus dados.",
            segments: "Segmentos",
            segments_help: "Acessa criação e gestão de segmentos.",
            rewards: "Recompensas",
            rewards_help: "Acessa o programa de recompensas.",
            reports: "Relatórios",
            reports_help: "Acessa métricas e relatórios do produto.",
            forms: "Formulário",
            forms_help: "Acessa formulários e respostas.",
            automations: "Automações",
            automations_help: "Acessa criação e gestão de automações.",
            balance: "Créditos SMS",
            balance_help: "Acessa saldo e consumo de créditos SMS.",
            configs: "Configurações",
            configs_help: "Acessa configurações do estabelecimento.",
            quotations: "Orçamentos",
            quotations_help: "Acessa orçamentos e propostas.",
            mcp: "MCP",
            mcp_help: "Acessa o MCP e integrações de agentes.",
            invoices: "Faturas",
            invoices_help: "Acessa faturas e cobranças do plano.",
            benefit_programs: "Central de Benefícios",
            benefit_programs_help: "Acessa a Central de Benefícios.",
            access_operations: "A quais operações o usuário tem acesso?",
            access_tasks: "A quais tarefas o usuário tem acesso?",
            access_quotations: "A quais orçamentos o usuário tem acesso?",
            global_access: "Possui acesso aos dados de todas as filiais",
            delete_clients: "Pode deletar clientes",
            dashboard_access_title: "Operações da dashboard",
            tasks_access_title: "Tarefas de Acesso ao Usuário",
            quotations_access_title: "Orçamento de Acesso ao Usuário",
            level_insert: "Inserção",
            level_read: "Leitura",
            scope_mine: "Próprias",
            scope_mine_plural: "Próprios",
            scope_branch: "Da unidade",
            scope_all_feminine: "Todas",
            scope_all_plural: "Todos",
        },
        validation: {
            name_required: "O nome é obrigatório.",
            name_min_length: "O nome deve ter no mínimo 3 caracteres.",
            email_required: "O e-mail é obrigatório.",
            email_valid: "O e-mail deve ser válido.",
            email_taken: "Este email está em uso.",
            password_required: "A senha é obrigatória.",
            password_min_length: "A senha deve ter no mínimo 6 caracteres.",
            permissions_required: "A permissão é obrigatória.",
            is_internal_required: "O uso interno é obrigatório.",
            active_required: "O Ativo é obrigatório.",
            branch_required: "A filial é obrigatória.",
            username_required: "O username é obrigatório.",
            username_min_length:
                "O username deve ter no mínimo 3 caracteres.",
            username_taken: "Este username está em uso.",
            tasks_access_required:
                "As Tarefas de Acesso ao Usuário são obrigatórias.",
            quotations_access_required:
                "Os Orçamentos de Acesso ao Usuário são obrigatórias.",
            dashboard_access_required:
                "As operações de PDV são obrigatórias.",
        },
    },
    plan: {
        title: "Plano ({0})",
        billing_type: "Tipo de mensalidade",
        billing_type_prepaid: "Pré-pago",
        billing_type_postpaid: "Pós-pago",
        base_fee: "Valor base",
        incentivized_revenue_share: "% Do faturamento incentivado",
        retention_revenue_share: "% Do faturamento de retenção",
        pricetable_clients: "Tabela de preço de clientes",
        pricetable_credits: "Tabela de preço de créditos",
        pricetable_extra_credits: "Tabela de preço créditos extras",
        included_integrations: "Integrações incluídas",
        price_per_integration: "Preço por integração extra",
        included_branches: "Filiais incluídas",
        price_per_branch: "Preço por filial",
        included_users: "Usuários incluídos",
        price_per_user: "Preço por usuário",
        save: "Salvar",
        notification: {
            saved: "Plano atualizado com sucesso",
            no_changes: "Nenhuma alteração detectada.",
            change_reason_required: "Informe o motivo da alteração antes de salvar.",
        },
    },
    // Details section
    details: {
        access_denied: "Acesso negado",
        activate: "Ativar",
        activate_automations: "Ativar automações",
        automations_locked: "Automações bloqueadas",
        automations_off: "Automações desligadas",
        automations_on: "Automações ligadas",
        block: "Bloquear",
        deactivate_automations: "Desativar automações",
        edit_info: "Editar informações",
        manage_plan: "Gerenciar plano",
        place_activated: "Estabelecimento ativado",
        place_blocked: "Estabelecimento bloqueado",
        view_as: "Ver como",
    },
    // Branches section
    branches: {
        add_branch: "Adicionar filial",
        neighborhood_city: "Bairro/Cidade",
        title: "Filiais",
        main_place_badge: "Matriz",
    },
    // Modules section
    modules: {
        title: "Módulos",
        updated: "Módulos atualizados",
    },
    // Products section
    products: {
        title: "Produtos Kevi",
        updated: "Produtos atualizados",
        at_least_one: "Pelo menos um produto deve permanecer ativo.",
        update_error: "Erro ao atualizar produtos.",
        names: {
            1: "Kevi Marketing",
            2: "Kevi Chat",
        },
    },
    // Plugins section
    plugins: {
        add_plugin: "Adicionar plugin",
        choose_plugin: "Escolher plugin",
        created_at: "Criado em",
        external_id: "ID externo",
        settings_updated: "Configurações atualizadas",
        title: "Plugins",
    },
    // Roles section
    roles: {
        new_role_placeholder: "Digite o nome do novo cargo",
        role_added: "Cargo adicionado",
        role_deleted: "Cargo excluído",
        role_updated: "Cargo atualizado",
        title: "Cargos",
    },
    // Users section
    users: {
        active: "Usuários ativos",
        add_user: "Adicionar usuário",
        title: "Usuários",
    },
    selected: "Selecionado",
    view_as: "Ver como",
    no_places_found: "Nenhum Estabelecimento encontrado",
    usage_report: {
        title: "Relatório de Adesão",
        general: "Geral",
        establishment: "Estabelecimento",
        orders: "Pedidos",
        total_income: "Receita total",
        new_clients: "Novos clientes",
        sign_ups: "Cadastros",
        sign_up_rate: "Taxa de cadastro",
        used_coupons: "Cupons utilizados",
        used_rewards: "Recompensas utilizadas",
        date: "Data",
        empty: "Não há dados suficientes para o período",
    },
    email_generator: {
        title: "Gerador de E-mail",
        placeholder: "padrão",
    },
};
